import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';


const ContentCard = ({ content, onPlay, onSave }) => {
  const [isSaved, setIsSaved] = useState(content?.isSaved || false);
  const [isPlaying, setIsPlaying] = useState(false);

  const handleSave = () => {
    setIsSaved(!isSaved);
    onSave(content?.id, !isSaved);
  };

  const handlePlay = () => {
    setIsPlaying(true);
    onPlay(content);
  };

  const formatDuration = (minutes) => {
    if (minutes < 60) return `${minutes} мин`;
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${hours}ч ${mins}м`;
  };

  const formatListeners = (count) => {
    if (count >= 1000) return `${(count / 1000)?.toFixed(1)}K`;
    return count?.toString();
  };

  return (
    <div className="content-card bg-card border border-border rounded-lg overflow-hidden hover:shadow-soft-lg transition-all duration-300 group">
      <div className="card-image-container relative aspect-video overflow-hidden bg-muted">
        <Image
          src={content?.artwork}
          alt={content?.artworkAlt}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
        
        {content?.isLive && (
          <div className="live-badge absolute top-3 left-3 px-3 py-1 rounded-full bg-error text-error-foreground flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-error-foreground animate-pulse"></span>
            <span className="text-xs font-semibold">В ЭФИРЕ</span>
          </div>
        )}

        <button
          onClick={handlePlay}
          className="play-overlay absolute inset-0 flex items-center justify-center bg-background/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
          aria-label="Воспроизвести"
        >
          <div className="play-button w-16 h-16 rounded-full bg-primary flex items-center justify-center shadow-soft-lg transform scale-90 group-hover:scale-100 transition-transform duration-300">
            <Icon name="Play" size={28} color="var(--color-primary-foreground)" />
          </div>
        </button>

        <div className="duration-badge absolute bottom-3 right-3 px-2 py-1 rounded bg-background/80 backdrop-blur-sm">
          <span className="text-xs font-mono text-foreground">
            {formatDuration(content?.duration)}
          </span>
        </div>
      </div>
      <div className="card-content p-4">
        <div className="flex items-start gap-3 mb-3">
          <div className="host-avatar w-10 h-10 rounded-full overflow-hidden bg-muted flex-shrink-0">
            <Image
              src={content?.hostAvatar}
              alt={content?.hostAvatarAlt}
              className="w-full h-full object-cover"
            />
          </div>
          
          <div className="flex-1 min-w-0">
            <h3 className="text-base font-heading font-semibold text-foreground line-clamp-2 mb-1">
              {content?.title}
            </h3>
            <p className="text-sm text-muted-foreground truncate">
              {content?.hostName}
            </p>
          </div>

          <button
            onClick={handleSave}
            className="save-button p-2 rounded-full hover:bg-muted transition-colors duration-200 flex-shrink-0"
            aria-label={isSaved ? 'Удалить из сохраненных' : 'Сохранить'}
          >
            <Icon 
              name={isSaved ? "BookmarkCheck" : "Bookmark"} 
              size={20} 
              color={isSaved ? "var(--color-primary)" : "var(--color-muted-foreground)"} 
            />
          </button>
        </div>

        <div className="card-meta flex items-center gap-4 text-xs text-muted-foreground mb-3">
          <div className="flex items-center gap-1">
            <Icon name="Users" size={14} color="currentColor" />
            <span>{formatListeners(content?.listeners)}</span>
          </div>
          <div className="flex items-center gap-1">
            <Icon name="Star" size={14} color="var(--color-warning)" />
            <span>{content?.rating?.toFixed(1)}</span>
          </div>
          <div className="flex items-center gap-1">
            <Icon name="Calendar" size={14} color="currentColor" />
            <span>{content?.date}</span>
          </div>
        </div>

        {content?.topics && content?.topics?.length > 0 && (
          <div className="card-topics flex flex-wrap gap-2">
            {content?.topics?.slice(0, 3)?.map((topic, index) => (
              <span
                key={index}
                className="topic-tag px-2 py-1 rounded-full bg-muted text-xs text-foreground"
              >
                {topic}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ContentCard;